import * as apiAuthentication from '@/network/api/authentication.api.js'
import * as apiPopup from '@/network/api/popup.api.js'
import * as apiAccounts from '@/network/api/accounts.api.js'
import * as apiCustomers from '@/network/api/customers/customers.api.js'
/* Assets */
import { removeItemFromSessionStorage } from '@/assets/scripts/windowStorage'
import { USER_SESSION } from '@/assets/constants/core'

/** login the user in the app and stores the info in the session storage and our store
@payload {Object}
@return {promise} - login request
*/
export const login = async (context, payload) => {
    const res = await apiAuthentication.login(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_USER_INFO', { ...data, isCompany: payload.isCompany })
        context.commit('SAVE_OUT_OF_BAND_VALIDATION_TYPE', payload.outOfBandValidationType)
        context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', data.session.remainingSecondsForSessionExpire)
    }
    return res
}

/** login the user in the app and stores the info in the session storage and our store
@payload {Object}
@return {promise} - login request
*/
export const enrollBiometricLogin = async (context, payload) => {
    const res = await apiAuthentication.biometricLogin(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_USER_INFO', { ...data, isCompany: payload.isCompany })
        context.commit('SAVE_OUT_OF_BAND_VALIDATION_TYPE', payload.outOfBandValidationType)
        context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', data.session.remainingSecondsForSessionExpire)
    }
    return res
}

/** login the user in the app and stores the info in the session storage and our store
@payload {Object}
@return {promise} - login request
*/
export const loginRememberMe = async (context, payload) => {
    const res = await apiAuthentication.loginRememberMe(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_USER_INFO', { ...data, isCompany: payload.isCompany })
        context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', data.session.remainingSecondsForSessionExpire)
    }
    return res
}

/** Invalidates rememberMeToken & force session storage clean and reload of page
@payload {Object}
@return {promise} -
*/
export const invalidRememberMe = async (context, payload) => {
    const res = await apiAuthentication.invalidRememberMe(payload)
    removeItemFromSessionStorage(USER_SESSION)
    window.localStorage.clear()
    window.location.reload(true)
    return res
}

/** logout the user in the app and removes info from stores and session storage
@return {promise} - logou request
*/
export const logout = async (context, payload) => {
    const res = await apiAuthentication.logout()
    removeItemFromSessionStorage(USER_SESSION)

    console.log(window.RevelockSdk, 'logout revelocksdk')

    /* Revelock Data */
    window.userIdentifier = null
    window.sessionIdentifier = null
    window.currentLocation = null
    window.RevelockSdk.clearSessionData()

    window.location.reload(true)
    return res
}

/** force session storage clean and reload of page
@return {void}
*/
export const forceLogout = () => {
    removeItemFromSessionStorage(USER_SESSION)
    window.location.reload(true)
    if (window.StatusBar) window.StatusBar.styleLightContent()
}

/**
@payload {Object}
@return {promise} -
*/
export const fetchBiometricChallenge = async (context, payload) => {
    const res = await apiAuthentication.getBiometricChallenge(payload)
    return res
}

/**
@payload {Boolean}
@return {Boolean} -
*/
export const updateMobileBiometric = (context, payload) => {
	context.commit('UPDATE_MOBILE_BIOMETRIC', payload)
}

/** login the user in the app and stores the info in the session storage and our store
@payload {Object}
@return {promise} - login request
*/
export const sendLoginBiometric = async (context, payload) => {
    const res = await apiAuthentication.sendLoginBiometricChallenge(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_USER_INFO', data)
        context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', data.session.remainingSecondsForSessionExpire)
    }
    return res
}

/** updates our session timer
@payload {Number}
@return {null}
*/
export const updateSessionTimer = async (context, payload) => {
    context.commit('UPDATE_SESSION_TIMER', payload)
}

/** extend session for our user
@payload {object}
@return {promise} - extend session request
*/
export const extendSession = async (context, payload) => {
    const res = await apiAuthentication.extendSession(payload)
    if (res) context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', res.data.data.remainingSecondsForSessionExpire)
    return res
}

/** extend session for our user with biometric data
@payload {object}
@return {promise} - extend session request
*/
export const sendExtensionBiometricChallenge = async (context, payload) => {
    const res = await apiAuthentication.sendExtensionBiometricChallenge(payload)
    if (res) context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', res.data.remainingSecondsForSessionExpire)
    return res
}

/** updates session expired state
@payload {Boolean} - session expired state
@return {void}
*/
export const updateSessionExpireState = (context, payload) => {
    context.commit('UPDATE_SESSION_EXPIRE_STATE', payload)
}

/** updates session timer with new mdw remaining secons
@return {void}
*/
export const updateRemainingSecondsForSessionExpire = (context, payload) => {
    context.commit('UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE', payload)
}

/** updates entity remember me info in store and localStorage
@payload {Object} - object with:
    entity: 234234234, // customer.bankingHolderId
    entityName: abasd asdasd // customer.name
    acession: {
        username: 123123, //param usado no login
        acessionNumber: 001429, // customer.username
        contractName: 'asdsad', // contractName
        type: COMPANY/PARTICULAR // depende da tab (existindo uma conta desse tipo),
        hasBiometricEnrolled: [true, false],
        avatarImageUrl: customer.avatarImageUrl
    }
}
@return {promise}
*/
export const updateEntityRememberMeInfo = async (context, payload) => {
    if (context.state.rememberMeEntityInfo && context.state.rememberMeEntityInfo.entity !== payload.entity) {
        return Promise.resolve({
            errorLevel: 'alert',
            errorCode: 'entity_not_match_saved'
        })
    }

    context.commit('UPDATE_ENTITY_REMEMBER_ME_INFO', payload)
    return Promise.resolve({ errorLevel: 'info' })
}

/** updates the selected acession
@payload {String, Number} - accessionNumber we want to mark as selected
@return {void}
*/
export const updateSelectedEntityRememberInfo = (context, payload) => {
    context.commit('UPDATE_SELECTED_ENTITY_REMEMBER_ME_INFO', payload)
}

/** updates the all entity remember me info in store and storage
@payload {Object} - All info saved in store with exchanges
@return {void}
*/
export const updateEntityRememberInfo = (context, payload) => {
    context.commit('UPDATE_ENTITY_REMEMBER_INFO', payload)
}

/** updates the selected acession theme
@payload {String} - current theme [dark, light]
@return {void}
*/
export const saveThemeInUserRememberMeSession = (context, payload) => {
    context.commit('UPDATE_SELECTED_ENTITY_THEME', payload)
}

/** removes an acession from entity remember me info in store and localStorage
@payload {String, Number} - accessionNumber we want to remove
@return {void}
*/
export const removeAcessionFromEntityRememberMeInfo = async (context, payload) => {
    context.commit('REMOVE_ACESSION_FROM_ENTITY_REMEMBER_ME_INFO', payload)
}

/** changes Account Group of Session
@return {promise}
*/
export const changeAccountGroupOfSession = async (context, payload) => {
    const res = await apiAuthentication.setSessionContractAccountGroup(payload)
    if (res) {
        context.commit('SAVES_CURRENT_SELECTED_ACCOUNT_GROUP', payload.data)
    }
    return res
}

/** requests popups for this session
@return {promise} - popups request
*/
export const requestPopupsList = async context => {
    const res = await apiPopup.requestPopupsList()
    if (res) {
        context.commit('SAVES_POPUPS_LIST', res.data.data.popUps)
    }
    return res
}

/** requests dismiss of popups for this customer
@return {promise} - dismiss popups
*/
export const requestDismissPopups = async (context, payload) => {
    const res = await apiPopup.dismissPopups(payload)
    if (res) {
        context.commit('CLEAR_POPUPS_LIST')
    }
    return res
}

/** clear popup list
@return {void}
*/
export const clearPopUpList = context => {
    context.commit('CLEAR_POPUPS_LIST')
}

/** updates customer session image url
@return {void}
*/
export const updateCustomerImageUrl = (context, payload) => {
    context.commit('UPDATE_CUSTOMER_IMAGE_URL', payload)
}

/** requests Out of band Validation Request Status
@return {promise} - Status
*/
export const getOutofBandValidationRequestStatus = async (context, payload) => {
    const res = await apiAuthentication.getOutofBandValidationRequestStatus()
    if (res) context.commit('UPDATE_SESSION_VALIDATION', res.data)

    return res
}

/** requests Out of band Validation Request Status
@return {promise} - Status
*/
export const retryOutofbandValidationRequest = async (context, payload) => {
    const res = await apiAuthentication.retryOutofbandValidationRequest()

    return res
}

/** requests Out of Band Request Detail
@return {promise} - Detail
*/
export const getOutofbandRequestDetail = async (context, payload) => {
    const res = await apiAuthentication.getOutofbandRequestDetail(payload)

    return res
}

/** requests Validate Refuse Out of Band Validation
@return {promise} - Response
*/
export const validateRefuseOutofbandValidationRequest = async (context, payload) => {
    const res = await apiAuthentication.validateRefuseOutofbandValidationRequest(payload)

    return res
}

/**
@return {promise} - Response
*/
export const updateDefaultAccountsGroup = async (context, payload) => {
    const res = await apiAccounts.accountsGroupDefault(payload)

    if (res) context.commit('UPDATE_INITIAL_ACTIONS', 'CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP')
    return res
}

export const updateAccountGroupInitialAction = async (context, payload) => {
    const res = await apiAuthentication.updateAccountGroupInitialAction()

    if (res) context.commit('UPDATE_INITIAL_ACTIONS', 'CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP')
    return res
}

/**
@return {promise} - Response
*/
export const updateSessionType = async (context, payload) => {
    context.commit('UPDATE_SESSION_TYPE')
}

/** Modifies password
@return { Promise }
*/
export const modifyPassword = async (context, payload) => {
    const res = await apiAuthentication.modifyPassword(payload)
    return res
}

/** Changes User Friendly Name
@return { promise }
*/
export const changeUserFriendlyName = async (context, payload) => {
    const res = await apiCustomers.changeUserFriendlyName(payload)
    return res
}

export const updateInitialActions = (context, payload) => {
    context.commit('UPDATE_INITIAL_ACTIONS', payload)
}
